import { type ComponentProps, memo } from 'react';

import { type Account, type ClipDiscussionResponse } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

import {
  PlayerSeekbarTimestampsMarker,
  type PlayerSeekbarTimestampsMarkerProps,
} from './PlayerSeekbarTimestampsMarker';

export type Marker = {
  discussion: ClipDiscussionResponse;
  endTimestamp?: number;
  initials: string;
  timestamp: number;
  userAvatar?: string;
  userId: Account['id'];
};

export type PlayerSeekbarTimestampsProps = ComponentProps<'div'> &
  Pick<PlayerSeekbarTimestampsMarkerProps, 'onMarkerSelect'> & {
    disabled?: boolean;
    getMarkerHighlight?: (marker: Marker) => boolean;
    markers: Marker[];
    onMarkerHoverChange?: (marker: Marker | null) => void;
  };

export const PlayerSeekbarTimestamps = memo(
  ({
    className,
    disabled = false,
    getMarkerHighlight,
    markers,
    onMarkerHoverChange,
    onMarkerSelect,
    ...restOfProps
  }: PlayerSeekbarTimestampsProps) => {
    return (
      <div
        className={cn('pointer-events-none absolute inset-0 z-10', className)}
        data-testid="PLAYER_SEEKBAR_TIMESTAMPS"
        {...restOfProps}
      >
        {markers.map((marker) => (
          <PlayerSeekbarTimestampsMarker
            disabled={disabled}
            highlight={getMarkerHighlight?.(marker)}
            key={marker.discussion.id}
            marker={marker}
            onHoverChange={onMarkerHoverChange}
            onMarkerSelect={onMarkerSelect}
          />
        ))}
      </div>
    );
  },
);

PlayerSeekbarTimestamps.displayName = 'PlayerSeekbarTimestamps';
